import { MuiAppBar } from './MuiAppBar';
import { MuiButton } from './MuiButton';
import { MuiButtonGroup } from './MuiButtonGroup';
import { MuiCheckbox } from './MuiCheckbox';
import { MuiCssBaseline } from './MuiCssBaseline';
import { MuiDialog } from './MuiDialog';
import { MuiInputBase } from './MuiInputBase';
import { MuiInputLabel } from './MuiInputLabel';
import { MuiMenu } from './MuiMenu';
import { MuiMenuItem } from './MuiMenuItem';
import { MuiOutlinedInput } from './MuiOutlinedInput';
import { MuiRadio } from './MuiRadio';
import { MuiSelect } from './MuiSelect';
import { MuiSlider } from './MuiSlider';
import { MuiTab } from './MuiTab';
import { MuiTabs } from './MuiTabs';

const components = {
  MuiAppBar,
  MuiButton,
  MuiCssBaseline,
  MuiDialog,
  MuiMenuItem,
  MuiMenu,
  MuiTab,
  MuiTabs,
  MuiInputBase,
  MuiInputLabel,
  MuiOutlinedInput,
  MuiSelect,
  MuiRadio,
  MuiCheckbox,
  MuiButtonGroup,
  MuiSlider,
};

export default components;
